// The floating bulk-action bar, tablet/desktop `#s06`: "N selected · both
// suggest X · Apply X / Other… / Personal". The primary "Apply <category>"
// action is only offered when every selected row shares one suggested
// category -- never guessed across a mixed selection.
import { Button } from '@moneyskyline/ui';

export function InboxBulkBar({
  count,
  sharedCategoryLabel,
  onApplyShared,
  onOther,
  onPersonal,
  pending,
}: {
  count: number;
  sharedCategoryLabel: string | null;
  onApplyShared: () => void;
  onOther: () => void;
  onPersonal: () => void;
  pending?: boolean;
}) {
  if (count === 0) return null;
  return (
    <div
      className="fixed inset-x-4 bottom-4 z-30 flex flex-wrap items-center gap-3 rounded-xl bg-primary px-4 py-3 text-sm text-primary-foreground shadow-bar md:inset-x-5"
      data-testid="inbox-bulk-bar"
    >
      <span className="font-semibold">
        {count} selected
      </span>
      <span className="flex-1 text-muted-foreground">
        {sharedCategoryLabel ? `both suggest ${sharedCategoryLabel}` : ''}
      </span>
      {sharedCategoryLabel && (
        <Button type="button" size="sm" variant="secondary" disabled={pending} onClick={onApplyShared}>
          Apply {sharedCategoryLabel}
        </Button>
      )}
      <Button type="button" size="sm" variant="outline" disabled={pending} onClick={onOther}>
        Other…
      </Button>
      <Button type="button" size="sm" variant="outline" disabled={pending} onClick={onPersonal}>
        Personal
      </Button>
    </div>
  );
}

export default InboxBulkBar;
